<ng-container *ngIf="(uxInteractions$ | async) as uxInteraction">
  <div *appLoadingUntil="!uxInteraction.userDetail.refreshing">

    <div id="profile" class="page-layout simple tabbed" *ngIf="currentUser$ | async as currentUser;">

      <!-- HEADER -->
      <div class="header p-24" [ngClass]="currentUser.type + '-bgColor'" fxLayout="column" fxLayoutAlign="center center" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="space-between end">
        <div class="user-info" fxLayout="column" fxLayoutAlign="center center" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start center">
          <img *ngIf="currentUser.userMedia" class="profile-image avatar huge" [src]="baseUrl + '/media/' + currentUser.userMedia + '/h/90'" [@animate]="{ value: '*', params: { delay: '50ms', scale: '0.2' } }" alt="avatar"/>

          <div *ngIf="!currentUser.userMedia && !currentUser.isSaasSuperAdmin" class="profile-image avatar huge icon" [ngClass]="currentUser.type">
            <img [src]="'https://avatars.dicebear.com/api/avataaars/'+currentUser.userId+'.svg'+avatarUrlExt" alt="">
          </div>

          <div *ngIf="!currentUser.userMedia && currentUser.isSaasSuperAdmin" class="profile-image avatar huge icon" [ngClass]="currentUser.type">
            <i class="md-fab mdi user-icon" [ngClass]="{'mdi-shield-account': currentUser.isSaasSuperAdmin, 'mdi-account': !currentUser.isSaasSuperAdmin}"></i>
          </div>

          <div fxLayout="column">
            <div fxFlex class="name" [@animate]="{ value: '*', params: { delay: '100ms', x: '-25px' } }">
              [{{ currentUser.userId }}]
            </div>

            <div fxFlex class="name" [@animate]="{ value: '*', params: { delay: '100ms', x: '-25px' } }">
              {{ currentUser?.fullname || currentUser.email }}
            </div>
          </div>

        </div>

        <div class="actions" fxLayout="row" fxLayoutAlign="end center" [@animate]="{ value: '*', params: { delay: '200ms' } }">

          <div class="login-button">

            <!--            <button mat-raised-button color="accent" aria-label="ConnectAs" (click)="connectAs(currentUser.userId, 'connectAs')">-->
            <!--              <i class="mdi mdi-key-arrow-right mdi-button"></i>-->
            <!--              Connect As-->
            <!--            </button>-->
            <!--            <button *ngIf="currentUser.isSaas && !currentUser.isSaasSuperAdmin" mat-icon-button color="accent" aria-label="saasConnectAs" (click)="connectAs(currentUser.userId, 'saasConnectAs')"><i class="mdi mdi-key-star mdi-button"></i></button>-->

          </div>

        </div>
      </div>
      <!-- / HEADER -->
      <mat-progress-bar *ngIf="uxInteraction.userDetail.refreshing" mode="indeterminate"></mat-progress-bar>
      <!-- CONTENT -->
      <div class="content" *ngIf="!uxInteraction.userDetail.refreshing">
        <mat-tab-group *ngIf="currentUser">

          <mat-tab label="User info">
            <ng-template matTabContent>
              <app-main-form [currentUser]="currentUser"></app-main-form>
            </ng-template>
          </mat-tab>

          <mat-tab label="Links" *ngIf="currentUser.type==='contributor'">
            <ng-template matTabContent>
              <app-publication-links-tab></app-publication-links-tab>
            </ng-template>
          </mat-tab>

          <mat-tab label="ExtProfils" *ngIf="currentUser.type==='contributor'">
            <ng-template matTabContent>
              <app-ext-profils-tab></app-ext-profils-tab>
            </ng-template>
          </mat-tab>

          <mat-tab label="Surveys" *ngIf="currentUser.type==='contributor'">
            <ng-template matTabContent>
              <app-surveys-details></app-surveys-details>
            </ng-template>
          </mat-tab>

          <ng-container *appIfUserHas="['GOD_MODE']">
            <mat-tab label="Transactions" *ngIf="currentUser.type==='contributor'">
              <ng-template matTabContent>
                <app-transactions-tab></app-transactions-tab>
              </ng-template>
            </mat-tab>
          </ng-container>

          <mat-tab label="Debug" *appIfUserHas="['GOD_MODE']">
            <ng-template matTabContent>
              <div style="height: calc(100vh - 282px); width: 100%;">
                <app-json-editor [autoExpand]="false" [readOnly]="true" [content]="currentUser"></app-json-editor>
              </div>
            </ng-template>
          </mat-tab>

        </mat-tab-group>


      </div>
      <!-- / CONTENT -->
    </div>

  </div>
</ng-container>
